import { FAVORITE_NEWS, REMOVE_FAVOURITE, ADD_FAVOURITE } from "../../../constants/actionTypes";
import * as interfaces from "../interfaces";

const favouriteNewsInitialState = {
  data: Array<interfaces.IArticlesItem>(),
  loading: false,
  page: 0,
  removeLoading: false,
  toBeRemovedId: 0,
  removeFailed: false,
  clearAllLoading: false,
  isDataFetched: false,
  moreArticlesPresent: true,
};

export const favoriteNewsReducer = (state = favouriteNewsInitialState, action: interfaces.IArticlesAction) => {
  const new_state = { ...state };
  switch (action.type) {
    case FAVORITE_NEWS.LOAD_SUCCESS:
      new_state.loading = false;
      new_state.isDataFetched = true;
      if (action.payload.length < 22) new_state.moreArticlesPresent = false;
      if (action.payload.length > 0) {
        new_state.data = [...state.data, ...action.payload];
        new_state.page += 1;
      }

      return new_state;
    case FAVORITE_NEWS.LOAD:
      new_state.loading = true;
      return new_state;
    case FAVORITE_NEWS.LOAD_FAIL:
      new_state.loading = false;
      return new_state;

    case FAVORITE_NEWS.ADD_CURATE:
      new_state.data = state.data.filter((item) => {
        // changing '==' from '===' becuase of type mismatch for same id in case of drag n drop from favorites to email browser in email edition
        if (item.id == action.curate_article_id) {
          item.is_curated = true;
        }
        return item;
      });
      return new_state;

    case FAVORITE_NEWS.REMOVE_CURATE:
      new_state.data = state.data.filter((item) => {
        if (item.id === action.curate_article_id) {
          item.is_curated = false;
        }
        return item;
      });
      return new_state;

    case FAVORITE_NEWS.REMOVE_ALL_CURATE:
      new_state.data = state.data.map((item) => {
        if (item.is_curated) {
          item.is_curated = false;
        }
        return item;
      });
      return new_state;

    case ADD_FAVOURITE.LOAD_SUCCESS:
      new_state.loading = false;
      new_state.moreArticlesPresent = true;
      if (new_state.page > 0) {
        new_state.data = [action.payload, ...state.data];
      }
      return new_state;
    case ADD_FAVOURITE.LOAD:
      new_state.loading = true;
      return new_state;
    case ADD_FAVOURITE.LOAD_FAIL:
      new_state.loading = false;
      return new_state;
    case REMOVE_FAVOURITE.LOAD:
      new_state.removeLoading = true;
      new_state.data = state.data.map((item) => {
        if (item.id === action.payload) {
          item.is_loading = true;
          item.is_removingFailed = false;
        }
        return item;
      });
      new_state.toBeRemovedId = action.payload;
      new_state.removeFailed = false;
      return new_state;
    case REMOVE_FAVOURITE.LOAD_SUCCESS:
      new_state.data = state.data.filter((item) => item.id !== state.toBeRemovedId);
      new_state.removeLoading = false;
      new_state.toBeRemovedId = 0;
      return new_state;
    case REMOVE_FAVOURITE.LOAD_FAIL:
      new_state.data = state.data.map((item) => {
        if (item.id === state.toBeRemovedId) {
          item.is_removingFailed = true;
          item.is_loading = false;
        }
        return item;
      });
      new_state.removeLoading = false;
      new_state.removeFailed = true;
      return new_state;
    case FAVORITE_NEWS.RESET:
      return favouriteNewsInitialState;
    default:
      return state;
  }
};
